import { PublicLayout } from '../components/Layout/PublicLayout'
import UpgradePng from './upgrade.png'
import { Headline1 } from '@jotta/ui/Headline'
import { Trans } from '@lingui/macro'
import { Link } from 'react-router-dom'
import { useGetCustomer } from '@jotta/grpc-connect-client/customer'
import { useBrandCode } from '@jotta/ui/useBrandTheme'
import type { Customer } from '@jotta/grpc-connect-openapi/esm/openapi/customer/customer.v2_pb'
import { showIntercom } from '@jotta/intercom'

export function ConvertedToJottacloud({ customer }: { customer: Customer }) {
  const customer_email = customer.email
  return (
    <>
      <header className="title-md text-center">
        <Trans>Welcome to Jottacloud!</Trans>
      </header>

      <img src={UpgradePng} className="h-64 px-16" />

      <p>
        <Trans>
          You are now a Jottacloud customer!{' '}
          <strong>All your data is safely stored in Jottacloud</strong>, but you
          will need to download the Jottacloud apps in order to continue backing
          up all your data.
        </Trans>
      </p>

      <p>
        <Trans>
          Please check your email ({customer_email}) for instructions on how to
          get started with the{' '}
          <a href="https://www.jottacloud.com/apps" className="link">
            Jottacloud service
          </a>
          .
        </Trans>
      </p>

      <p>
        <Trans>
          If you have any questions, please{' '}
          <a
            className="link"
            href="mailto:support@jottacloud.com"
            onClick={showIntercom}
            target="_blank"
            rel="noreferrer"
          >
            contact support
          </a>
          .
        </Trans>
      </p>
    </>
  )
}

function Upgraded() {
  return (
    <>
      <Headline1>
        <Trans>Your account has been upgraded!</Trans>
      </Headline1>
      <img src={UpgradePng} className="h-80" />
      <p>
        <Trans>
          Congratulations on your new subscription! You will shortly receive a
          payment receipt by email.
        </Trans>
      </p>
      <Link to="/web/billing" className="link">
        <Trans>Continue</Trans>
      </Link>
    </>
  )
}

export function UpgradeAccepted() {
  const { data: customer } = useGetCustomer()
  const siteBrandCode = useBrandCode()
  const customerBrandCode = customer
    ? customer.brandingInfo?.brandCode
    : undefined

  return (
    <PublicLayout
      section="upgradeaccepted"
      className="mx-auto flex max-w-xl flex-col items-center gap-4 py-8 text-center"
    >
      {customer &&
      customerBrandCode !== siteBrandCode &&
      customerBrandCode === 'JOTTACLOUD' ? (
        <ConvertedToJottacloud customer={customer} />
      ) : (
        <Upgraded />
      )}
    </PublicLayout>
  )
}
